import Image from 'next/image';

import { StarRating } from '../star-rating';
import { Text } from '../text';

import type { ReviewItem } from '@/app/generated/graphql';

export const ReviewCard = ({
  rating,
  review,
  reviewDate,
  reviewerName,
  reviewProvider,
  state,
  title,
}: Pick<
  ReviewItem,
  'review' | 'rating' | 'reviewerName' | 'reviewProvider' | 'state' | 'title' | 'reviewDate'
>) => {
  if (!review) {
    return null;
  }

  // Added to remove quotes added so as we can wrap the text if needed.
  const quotePattern = /^(?<temp1>['"“])(?:.*)\1$/;

  const hasQuotes = quotePattern.test(review);

  const formattedReview = hasQuotes
    ? `“${review.substring(1, review.length - 1)}”`
    : `“${review}”`;

  return (
    <div
      className="flex h-full min-h-[330px] flex-col gap-[8px] rounded-rad-c bg-white px-[32px] py-[16px]"
      data-testid="review-card"
    >
      <div className="flex flex-col gap-[8px]">
        <div className="flex justify-between">
          <div className="flex items-center gap-a pr-[4px]">
            <Image
              src={reviewProvider?.image?.url ?? ''}
              alt={reviewProvider?.image?.description ?? ''}
              width={24}
              height={24}
              data-testid="review-provider-logo"
            />
            <Text
              variant="body3"
              className="leading-[27px]"
            >
              {rating ?? 0}/5 on {reviewProvider?.title}
            </Text>
          </div>
          <Text
            variant="body3"
            className="leading-[27px]"
          >
            {new Date(String(reviewDate)).toLocaleString('en-US', { month: 'short' })}{' '}
            {new Date(String(reviewDate)).getFullYear()}
          </Text>
        </div>
        <StarRating rating={rating ?? 0} />
      </div>
      <Text
        variant="body2"
        weight="bold"
      >
        {title}
      </Text>
      <Text
        variant="body2"
        className="grow"
      >
        {formattedReview}
      </Text>
      <Text
        variant="body3"
        weight="semi"
      >
        {reviewerName}
        {state ? `, ${state}` : ''}
      </Text>
    </div>
  );
};
